import React from 'react';

// More coming later...
// Just here so react/typescript can have the imports for testing locally.
export const StaticSplash: React.FC = () => {
  return <div>Static Splash Page</div>;
};
